module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "flexContainer fd-c",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "configurator"
    }
  }, [(_vm.displayProductSelect) ? _c('ProductSelect', {
    attrs: {
      "position": _vm.position
    }
  }) : _vm._e(), _vm._v(" "), (_vm.displayTicketStripSelect) ? _c('TicketStripSelect', {
    attrs: {
      "ticketStrips": this.proptickets
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-bbar"
  }, [_c('div', {
    staticClass: "buttonbar-left"
  }, [_c('div', {
    staticClass: "configuratorBox"
  }, [_c('div', {
    staticClass: "inputBox"
  }, [_c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "configWidth"
    }
  }, [_vm._v("Width")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configWidth),
      expression: "configWidth"
    }],
    attrs: {
      "type": "number",
      "step": "1",
      "min": "0",
      "id": "configWidth"
    },
    domProps: {
      "value": (_vm.configWidth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.configWidth = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inputBox"
  }, [_c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "configHeight"
    }
  }, [_vm._v("Height")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configHeight),
      expression: "configHeight"
    }],
    attrs: {
      "type": "number",
      "step": "1",
      "min": "0",
      "id": "configHeight"
    },
    domProps: {
      "value": (_vm.configHeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.configHeight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "snapCheckbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.snapUp),
      expression: "snapUp"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "snapUp"
    },
    domProps: {
      "checked": Array.isArray(_vm.snapUp) ? _vm._i(_vm.snapUp, null) > -1 : (_vm.snapUp)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.snapUp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.snapUp = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.snapUp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.snapUp = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "snapUp"
    }
  }, [_vm._v("Snap Up")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.cleanConfig();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("configurator.cleanConf")))])]), _vm._v(" "), _c('div', {
    staticClass: "buttonbar-right"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.save(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("configurator.save")))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.save(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("configurator.saveClose")))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.close();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("configurator.close")))])])]), _vm._v(" "), _c('svg', {
    staticClass: "builder-configurator-module",
    attrs: {
      "id": "builderConfigurator"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "buttonbar"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.confirmGroup
    }
  }, [_vm._v(_vm._s(_vm.$t("configurator.confirmGroup")))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-545d0235","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/Configurator.vue
// module id = 3188
// module chunks = 0